import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center group">
              <div className="h-8 w-8 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center transform transition-transform group-hover:scale-110">
                <span className="text-white font-bold">C</span>
              </div>
              <span className="ml-2 text-xl font-bold text-white group-hover:text-blue-400 transition-colors">
                CashBitAI
              </span>
            </Link>
            <p className="mt-4 text-sm">
              Your AI-powered financial assistant for smarter money management.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2">
              <li><a href="#features" className="hover:text-white hover:translate-x-1 transition-all inline-block">Features</a></li>
              <li><a href="#pricing" className="hover:text-white hover:translate-x-1 transition-all inline-block">Pricing</a></li>
              <li><a href="#how-it-works" className="hover:text-white hover:translate-x-1 transition-all inline-block">How It Works</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white hover:translate-x-1 transition-all inline-block">About</a></li>
              <li><a href="#" className="hover:text-white hover:translate-x-1 transition-all inline-block">Blog</a></li>
              <li><a href="#" className="hover:text-white hover:translate-x-1 transition-all inline-block">Careers</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white hover:translate-x-1 transition-all inline-block">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white hover:translate-x-1 transition-all inline-block">Terms of Service</a></li>
              <li><a href="#" className="hover:text-white hover:translate-x-1 transition-all inline-block">Security</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} CashBitAI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;